export default __webpack_public_path__ + "static/media/rs.53126246.svg";